import { render, staticRenderFns } from "./Drug.vue?vue&type=template&id=2ea51014&scoped=true"
import script from "./Drug.vue?vue&type=script&lang=js"
export * from "./Drug.vue?vue&type=script&lang=js"
import style0 from "./Drug.vue?vue&type=style&index=0&id=2ea51014&prod&scoped=true&lang=css"
import style1 from "./Drug.vue?vue&type=style&index=1&id=2ea51014&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea51014",
  null
  
)

export default component.exports